// utils/analytics.ts

// This is a type declaration for the gtag function, which is globally available from the Google Analytics script
declare global {
    interface Window {
      gtag: (...args: any[]) => void;
    }
}
  
/**
 * Updates the user's consent for Google Analytics.
 * This should be called when the user saves their cookie preferences.
 */
export const updateConsent = (analytics: boolean, marketing: boolean) => {
    if (typeof window.gtag !== 'function') {
        return;
    }
    window.gtag('consent', 'update', {
        'analytics_storage': analytics ? 'granted' : 'denied',
        // In GA4, ad_storage controls marketing/advertising features.
        'ad_storage': marketing ? 'granted' : 'denied' 
    });
};

/**
 * Initializes analytics based on stored consent.
 * This should be called once when the application loads.
 */
export const initializeAnalytics = () => {
    try {
        const consent = localStorage.getItem('cookieConsent');
        if (consent) {
            const settings = JSON.parse(consent);
            updateConsent(settings.analytics, settings.marketing);
        }
    } catch (error) {
        console.error("Failed to initialize analytics consent:", error);
    }
};
